import { Divider, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import { Delete, Plus } from "mdi-material-ui";
import React, { useState } from "react";

import ParticipantInput from "./ParticipantInput";
import { PracticeGameSchedulesForm } from "./PracticeForm";

AddPracticeGameScheduleDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Schedule Practice Game",
  };
};

export default function AddPracticeGameScheduleDialog({ orgId, courtId, onSubmit, onClose }) {
  const addPracticeSchedule = useActionFragment("addPracticeGameSchedule", "gameSchedule { id }");
  const [participants, setParticipants] = useState([]);

  const handleAddParticipant = (participant) => {
    setParticipants((prev) => [...prev, participant]);
  };
  const handleRemoveParticipant = (personId) => {
    setParticipants((prev) => prev.filter((p) => p.person_id !== personId));
  };

  return (
    <FormDialog
      header="Schedule Practice Game"
      onClose={onClose}
      onSubmit={async (formData) => {
        const payload = {
          ...formData,
          people: participants.map((p) => ({
            personId: p.person_id,
            role: "Spectator",
          })),
        };

        const result = await addPracticeSchedule({ input: payload });
        await onSubmit?.(result.addPracticeGameSchedule.gameSchedule);
      }}
    >
      <PracticeGameSchedulesForm orgId={orgId} courtId={courtId} />

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" component="h3" sx={{ mt: 0, mb: 1 }}>
        Spectators
      </Typography>

      {participants.length > 0 && (
        <>
          <List dense>
            {participants.map((p) => (
              <ListItem
                key={p.person_id}
                secondaryAction={
                  <IconButton edge="end" onClick={() => handleRemoveParticipant(p.person_id)}>
                    <Delete />
                  </IconButton>
                }
              >
                <ListItemText primary={p.name} />
              </ListItem>
            ))}
          </List>
        </>
      )}

      <ParticipantInput onAddParticipant={handleAddParticipant} participants={participants} />
    </FormDialog>
  );
}
